module.exports = __webpack_public_path__ + "static/media/clinically-tested-icon.99c52e12.png";